import { put, takeLatest, call, select } from 'redux-saga/effects';

import { createStandaloneToast, theme } from '@frontend/components';

import { assemblyTree } from 'modules/quotes/quoteItemComponents/assemblyTree/data/actions';
import {
  briefComponent,
  refreshBomRollup,
} from 'modules/quotes/quoteItems/data/actions';
import quoteItemService from 'modules/quotes/quoteItems/data/service';

import purchasedComponentService from 'services/purchasedComponentsService';
import quoteService from 'services/quoteService';

import {
  saveComponent,
  fetchSmartMatches,
  purchasedComponentsDrawer,
  types,
} from './actions';
import { MODES, TABS } from './constants';
import { getComponentId, getMode } from './reducer';

const { toast } = createStandaloneToast({ theme });

export default function* root() {
  yield takeLatest(types.SAVE_COMPONENT_REQUEST, watchSaveComponent);
  yield takeLatest(types.SAVE_COMPONENT_AND_LINK_PRODUCT, watchLinkProduct);
  yield takeLatest(types.FETCH_SMART_MATCHES_REQUEST, watchFetchSmartMatches);
  yield takeLatest(types.OPEN, watchInitiateDrawer);
}

function* watchLinkProduct(action) {
  try {
    const { productId, purchasedComponentId } = action.payload;

    yield call(purchasedComponentService.update, purchasedComponentId, {
      productId,
    });

    yield put(saveComponent.request({ purchasedComponentId }));
  } catch (error) {
    yield put(saveComponent.error(error));
  }
}

function* watchSaveComponent(action) {
  try {
    const componentId = yield select(getComponentId);
    const mode = yield select(getMode);
    const { purchasedComponentId } = action.payload;

    let response;
    if (mode === MODES.CONVERT) {
      response = yield call(
        quoteItemService.components.convertToPurchasedComponent,
        componentId,
        { purchasedComponentId },
      );
      yield call(toast, {
        status: 'success',
        title: 'Converted to Purchased Component',
        description:
          'The manufactured component was successfully converted to a purchased component',
      });
    } else {
      response = yield call(
        quoteItemService.components.changePurchasedComponent,
        componentId,
        { purchasedComponentId },
      );
      yield call(toast, {
        status: 'success',
        title: 'Changed Purchased Component',
        description: 'The purchased component was successfully changed',
      });
    }

    // Refresh the quote
    yield put(briefComponent.receive({ briefComponent: response }));
    yield put(
      refreshBomRollup.request({
        parentComponentIds: response.parentComponentIds,
        delayTime: 0,
        shouldFullyRefreshRootOrExpandedComponents: true,
      }),
    );

    yield put(assemblyTree.markNeedsUpdate({}));
    yield put(saveComponent.success());
  } catch (error) {
    yield put(saveComponent.error(error));
  }
}

function* watchFetchSmartMatches() {
  try {
    const componentId = yield select(getComponentId);
    const { products, purchasedComponents } = yield call(
      quoteService.components.purchasedComponentsSearch,
      componentId,
    );

    yield put(fetchSmartMatches.success({ products, purchasedComponents }));

    if (!products?.length && !purchasedComponents?.length) {
      // switch to search tab if no smart matches
      yield put(purchasedComponentsDrawer.setActiveTab({ tab: TABS.SEARCH }));
    }
  } catch (error) {
    yield put(fetchSmartMatches.error(error));
  }
}

function* watchInitiateDrawer() {
  const mode = yield select(getMode);
  if (mode != MODES.ADD) {
    try {
      yield put(fetchSmartMatches.request());
    } catch (error) {
      console.error('Error when initiating Purchased Components Drawer', error);
    }
  }
}
